var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-wrapper label"},[_c('div',{staticClass:"message-content text--break",class:{ 'message-channel': _vm.isFinish }},[_vm._v(" "+_vm._s(_vm.textFinish)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }